import { useEffect, useState } from 'react';
import '../../../css/SoccerTeamHomePage.css';
import ScheduleBox from '../../../components/ScheduleBox';
import RecentBox from '../../../components/RecentBox';
import RosterBox from '../../../components/RosterBox';
import PLsoccerLogos from '../../../assets/PLsoccerLogos';
import Record from '../../../components/Record';

const NewcastleHome = () => {
    const [isTeamFavorite, setIsTeamFavorite] = useState(false);
    const [starredPlayers, setStarredPlayers] = useState([]);
    const [favoritesLoaded, setFavoritesLoaded] = useState(false);

    const handleSaveFavorites = async (players = starredPlayers, teamFav = isTeamFavorite) => {
        const filteredPlayers = players.filter(playerKey => playerKey.startsWith("Newcastle"));
        
        const fav = {
            teamName: "Newcastle",
            teamLogo: PLsoccerLogos["Newcastle"],
            isTeamFavorite: teamFav,
            players: filteredPlayers.map(player => ({
                name: player,
                isFavorite: true
            }))
        };

         try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/save`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(fav),
            });

        } catch(err) {
            console.error("Error saving favorites: ", err);
        }
    };

    useEffect(() => {
            const fetchFavorites = async () => {
                try {
                        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/favorites/get?team=Newcastle`, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                        credentials: "include",
                    });
        
                    if (!res.ok) {
                        console.log("No favorites found or error fetching");
                        setFavoritesLoaded(true);
                        return;
                    }
                    const data = await res.json();
        
                    // highlight team star
                    setIsTeamFavorite(data.team?.isFavorite || false);
        
                    // highlight player stars
                    const playerKeys = data.players
                        .filter(p => p.isFavorite && p.name.startsWith("Newcastle"))
                        .map(p => p.name);  
                    setStarredPlayers(playerKeys);
                    setFavoritesLoaded(true);
    
                } catch (err) {
                    console.error("Error fetching favorites", err);
                }
            };
        
            fetchFavorites();
        }, []);

    return (
        <div>
            <section className="soccer-top-row">
                <section className="soccer-team-info">
                    <img
                        className="soccer-team-logo"
                        src={PLsoccerLogos["Newcastle United"]}
                        alt="Newcastle United"
                    />
                    <div className="soccer-team-text">
                        <div className="soccer-title-row">
                            <h1>Newcastle United</h1>
                            <button
                                type="button"
                                className="soccer-favorite-btn"
                                onClick={() => {
                                    const newVal = !isTeamFavorite;
                                    setIsTeamFavorite(newVal);
                                    handleSaveFavorites(starredPlayers, newVal); 
                                }}
                                aria-label="Toggle favorite"
                            >
                                {isTeamFavorite ? '★' : '☆'}
                            </button>
                        </div>
                        <p><span className="soccer-label">Record:</span> <Record name="Newcastle United" /></p>
                        <p><span className="soccer-label">Stadium:</span> St James' Park</p>
                        <p><span className="soccer-label">Head Coach / Manager:</span> Eddie Howe</p>
                        <p><span className="soccer-label">Assistant Staff:</span> Jason Tindall, Stephen Purches, Graeme Jones, Ben Dawson, Simon Weatherstone</p>
                    </div>
                </section>
            </section>

            <div className="soccer-team-content">
                <section className="soccer-left-content">
                    <h2>Roster</h2>
                    {favoritesLoaded && (
                    <RosterBox
                        teamName="Newcastle United"
                        sport="soccer"
                        favoritePlayers={starredPlayers || []} 
                        onFavoriteChange={(updatedPlayers) => {
                            setStarredPlayers(updatedPlayers);
                            handleSaveFavorites(updatedPlayers, isTeamFavorite);
                        }}
                    />
                    )}
                </section>

                <section className="soccer-middle-content">
                    <h2>Recent Matches</h2>
                    <RecentBox teamName="Newcastle United" />

                    <h2>Upcoming Matches</h2>
                    <ScheduleBox teamName="Newcastle United" />
                </section>

                <section className="soccer-right-content">
                    <h2>Fun Facts</h2>
                    <div className="soccer-box">
                        <p>• Nicknamed “The Magpies” for their iconic black and white kit</p>
                        <br />
                        <p>• Used to have held the global transfer fee record for their purchase of Alan Shearer, the Premier League’s top goal scorer</p>
                        <br />
                        <p>• Windshield wipers were invented by Newcastle’s official team photographer in early 1900s</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default NewcastleHome;